import {
  MainNavigation,
  MobileNavigation,
  Responsive,
} from "components/commons";
import React, { useEffect, useState } from "react";
import { ReactComponent as Icon } from "assets/images/icon.svg";
import { useWallets } from "@privy-io/react-auth";
import { formatAmount } from "utils/number/number";
import { useLocation, useNavigate } from "react-router-dom";
import slugs from "navigation/slugs";
import { ReactComponent as Eth } from "assets/icons/eth.svg";
import { LandingPage } from "components/commons/LandingPage";
import { appConfig } from "services/blockchain";
import { MainLayoutPublib } from "../MainLayoutPublib";

interface Props {
  children: React.ReactNode;
}

export const MainLayout: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [balance, setBalance] = useState("");

  const { wallets } = useWallets();
  const embeddedWallet = wallets.find(
    (wallet) => wallet.walletClientType === "privy"
  );

  useEffect(() => {
    const getBalanceBase = async () => {
      if (!embeddedWallet) return;
      const balance = await appConfig.provider.getBalance(
        embeddedWallet?.address
      );
      setBalance(formatAmount(balance ?? "0", 18, 4));
    };
    getBalanceBase();
  }, [embeddedWallet]);

  const isHiddenHeader = [
    slugs.profile,
    slugs.otherProfile,
    slugs.inbox,
  ].includes(pathname);

  const isInStandaloneMode = window.matchMedia(
    "(display-mode: standalone)"
  ).matches;

  return (
    <>
      {isInStandaloneMode ? (
        <div className="main-layout--wrapper min-h-screen min-w-screen bg-base-300">
          <div className="flex flex-col items-stretch w-full h-full transition-all lg:pl-72 overflow-hidden">
            <Responsive from={"lg"}>
              <div className="w-72 fixed top-0 bottom-0 transition-all left-0">
                {/* Sidebar */}
                <MainNavigation />
                {/* // Sidebar */}
              </div>
            </Responsive>
            {/* Mobile Bottom Navigation */}
            <Responsive upto={"md"}>
              <MobileNavigation />
            </Responsive>
            {/* // Mobile Bottom Navigation */}

            {isHiddenHeader ? null : (
              <div className="flex gap-2 justify-between items-center h-12 fixed top-0 w-full md:hidden bg-base-300 px-4 py-2 z-10">
                <div className="flex-1">
                  <img
                    src="/svgs/live-icon.svg"
                    alt=""
                    onClick={() => navigate(slugs.live, { replace: true })}
                  />
                </div>
                <div className="flex-1">
                  <Icon className="w-8 h-8 mx-auto" />
                </div>
                <div className="flex-1">
                  <div
                    className="flex items-center justify-between border border-gray-700 gap-1 rounded-xl px-3 py-[6px]"
                    onClick={() => navigate(slugs.profileBalance)}
                  >
                    <Eth className="w-4" /> {balance}
                  </div>
                </div>
              </div>
            )}

            {/* Content Area */}
            <div
              className={`flex-1 flex flex-col w-full min-h-screen h-full text-base-content p-4`}
            >
              {pathname === slugs.inbox ? null : (
                <div className="h-10 block"> </div>
              )}
              {children}
              <div className="h-16 block"> </div>
            </div>
            {/* //Content Area */}
          </div>
        </div>
      ) : (
        <MainLayoutPublib>
          <div className="min-h-screen flex-1 flex flex-col h-full w-full justify-center items-center">
            <LandingPage />
          </div>
        </MainLayoutPublib>
      )}
    </>
  );
};
